import { put, takeLatest, call, select } from 'redux-saga/effects';
import { requestSuccess, requestFailure, clickWatch } from './actionCreators';
import { RequestError } from './types';
import { requestPuppy } from '@wix/da-http-client/pkg/request';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { restrictLoggedOut } from '../../redux/loggedout';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { isGroup } from '../../User/helpers';
import { toggleWatchGroup } from '../../NetworkBar/redux/actions';
export function fakeResponse() {
    return {
        success: true
    };
}
function getError(result) {
    if (result && result.error_code !== undefined && RequestError[result.error_code] !== undefined) {
        return result.error_code;
    }
    return RequestError.GeneralError;
}
export function* toggleWatch({ payload: { user, isWatching, onToggleWatchSuccess } }) {
    const apiMethod = isWatching ? 'unwatch' : 'watch';
    const loggedIn = yield select(getIsLoggedIn);
    if (!loggedIn) {
        yield put(restrictLoggedOut({
            restrictedActionName: ReferralType.WATCH
        }));
        return;
    }
    const result = yield call(requestPuppy, {
        method: 'post',
        url: `user/${apiMethod}`,
        data: {
            username: user.username
        }
    }, fakeResponse);
    if (result && result.success) {
        const newIsWatching = !isWatching;
        yield put(requestSuccess(user.username, newIsWatching));
        if (isGroup(user)) {
            yield put(toggleWatchGroup(user.userId, newIsWatching));
        }
        onToggleWatchSuccess && onToggleWatchSuccess(newIsWatching);
    } else {
        yield put(requestFailure(user.username, getError(result)));
    }
}
function* saga() {
    yield takeLatest(clickWatch, toggleWatch);
}
export default saga;

//# sourceMappingURL=saga.js.map